import { render } from "./ShippingMethodPostCodes.vue?vue&type=template&id=372c59f9&scoped=true&ts=true"
import script from "./ShippingMethodPostCodes.vue?vue&type=script&lang=ts"
export * from "./ShippingMethodPostCodes.vue?vue&type=script&lang=ts"

import "./ShippingMethodPostCodes.vue?vue&type=style&index=0&id=372c59f9&scoped=true&lang=css"

import exportComponent from "/home/uat/uatdan_yrshop_admin/public_html/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-372c59f9"]])

export default __exports__